export default {
    "kt": "Khởi tạo",
    "sdc": "Sai địa chỉ",
    "odz": "ODZ",
    "k": "Khác",
    "ht": "Hoàn thành",
    "h": "Hủy",
}
